import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import FeatureWrapper from '../FeatureWrapper'
import FeatureTitle from '../FeatureTitle'
import FeatureItems from '../FeatureItems'
import { withRouter } from 'react-router'

import { Select, Option } from 'react-a11y-select'
import 'react-a11y-select/src/styles.css'

const getSizes = SkuByType => {
  const _COR = SkuByType.filter(x => x.currentSku === true)[0].COR

  const listMap = SkuByType.filter(x => x.COR === _COR)

  return listMap.sort((a, b) => {
    var nameA = a.TAMANHO && a.TAMANHO.toLowerCase()
    var nameB = b.TAMANHO && b.TAMANHO.toLowerCase()
    if (nameA < nameB) return -1
    if (nameA > nameB) return 1
    return 0
  })
}
const getSKUSelected = SkuByType => {
  return SkuByType.filter(x => x.currentSku === true)[0].sku
}

const SizeFeature = ({ history: { push }, SkuByType }) => {
  const selectedSize = (e) => {
    push(`/products/${e}`)

    setTimeout(() => {
      var goToMainContent = document.getElementById('go-to-main-content')
      goToMainContent.focus()
    }, 1000)
  }

  useEffect(() => {
    var listIds = document.querySelectorAll('#opcao-voltagem-list > li')

    if (listIds && listIds.length > 0) {
      Array.from(listIds).forEach(removeId => {
        removeId.removeAttribute('id')
      })
    }
  })

  return (
    <FeatureWrapper>
      <FeatureTitle ariaLabelledby='opcao-tamanho'>Selecione o tamanho:</FeatureTitle>
      <FeatureItems className='px-1'>
        <Select buttonId='opcao-voltagem-button' listId='opcao-voltagem-list' ariaLabelledby='opcao-voltagem' label='Selecione o tamanho' placeholderText={`Nenhum tamanho selecionado`} initialValue={getSKUSelected(SkuByType)} onChange={e => selectedSize(e)}>
          {
            getSizes(SkuByType).map(size => {
              return size.TAMANHO && (
                <Option value={size.sku} label={size.TAMANHO}>
                  {size.TAMANHO}
                </Option>
              )
            })
          }
        </Select>
      </FeatureItems>
    </FeatureWrapper>
  )
}

SizeFeature.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  SkuByType: PropTypes.array
}

export default withRouter(SizeFeature)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Feature/FeatureContainer/SizeFeature.js